module.exports = __webpack_public_path__ + "static/media/mastercard.0f0c30da.svg";